/**
 * Store
 * 设计器页面共用逻辑以及部分子组件与父组件通讯
 */

class Store {
  constructor(crudEditOfDesign, initialState = {}, initialMutations) {
    this.crudEditOfDesign = crudEditOfDesign

    //状态数据
    this.states = {
      selectdFieldName: null,
      //页面切换时不需缓存的数据
      provisional: {
        crudArrayOrderTableRef: null,
      },
    }

    //修改states的方法
    this.mutations = {
      setSelectdFieldName(states, data) {
        this.states.selectdFieldName = data
      },
      setCrudArrayOrderTableRef(states, data) {
        this.states.provisional.crudArrayOrderTableRef = data
      },
    }
    //操作方法
    this.actions = {}

    //初始赋值自定义state
    for (let prop in initialState) {
      if (initialState.hasOwnProperty(prop) && this.states.hasOwnProperty(prop)) {
        this.states[prop] = initialState[prop]
      }
    }

    //初始赋值自定义mutations
    for (let prop in initialMutations) {
      if (initialMutations.hasOwnProperty(prop)) {
        this.mutations[prop] = initialMutations[prop]
      }
    }
  }

  commit(name, ...args) {
    const mutations = this.mutations
    if (mutations[name]) {
      mutations[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }

  dispatch(name, ...args) {
    const actions = this.actions
    if (actions[name]) {
      return actions[name].apply(this, [this.states].concat(args))
    } else {
      console.error(`未定义${name}方法`)
    }
  }
}

export default Store
